import { useMemo } from 'react';
import debounce from 'lodash/debounce';
import TranslationText from '@Components/Utilities/TranslationText';
import Modal from '@Components/Shared/Modals/Modal';
import { hasCurrentUserLocationCookie } from '@Components/Utilities/CookieHelper';
import {  gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import {  gtmEventType } from '@Components/Utilities/SandhillsConstants';

const SortDropdown = (props) => {
    const DefaultSortValue = 1;
    const DistanceSortValue = 6;
    const delayQuery = useMemo(() => debounce(e => props.OnChange(e), 500), [props.OnChange]);

    const isDefaultSelected = parseInt(props.SelectedValue) === DefaultSortValue;
    const specificSortClass = isDefaultSelected ? 'default' : '';

    const changeSort = (e, name) => {
        gtmPushEvent(gtmEventType.sortSelected, 'sortName', name ? name : e);
        let sort = parseInt(e.target ? e.target.value : e)
        if (props.setShowDistanceModal && sort === DistanceSortValue && !hasCurrentUserLocationCookie()) {
            props.setShowDistanceModal(true)
        } else {
            delayQuery(sort);
        } 
    };

    const onClose = (e) => {
        props.toggleMobileSort();
    };

    const calculateSortHeight = () => {
        let sortHeight = 'auto';
        if (props.isFromNavBar) {
            sortHeight = props.openBar ? '39.5px' : '11.5px';
        }
        return sortHeight;
    } 

    return (props.IsDesktop && !props.SortButton ?
        <div className='list-sort-order'>
            <div className={`sort-by-dropdown-container ${specificSortClass}`}>
                <label htmlFor='sort'>
                    <strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.sortby' />:</strong>
                </label>
                &nbsp;
                <select className='list-sort-order-select' id='sort' value={props.SelectedValue || ''} onChange={changeSort}>
                    {props.SortOptions.map(sortItem => <option key={'desktop-' + sortItem.Key} value={sortItem.Key}>{sortItem.Value}</option>)}
                </select>
            </div>
        </div>
        :
        <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); props.toggleMobileSort(); } }} className={props.mobileCSSClass ? props.mobileCSSClass : props.IsDesktop ? 'sort-button-spoof' : 'option-bar-option'} id={props.isSticky ? 'option-bar-sort-sticky' : 'option-bar-sort'} onClick={props.toggleMobileSort} style={{ height: calculateSortHeight(), marginLeft: props.UseLimitedBar && props.IsDesktop ? 'auto' : ''}}>
            {props.isFromNavBar ? (
                props.openBar ? (
                    <i className='fas fa-sort-amount-down'></i>
                ) : null
            ) : (
                <i className='fas fa-sort-amount-down'></i>
            )}
            <br />
            <span className={props.IsDesktop ? '' : 'uppercase'}>
                <TranslationText tKey='sandhills.sort' />
            </span>
            {props.ShowMobileSort &&
                <Modal containerClassName='sort-option-container' onEscapeKeyClose={onClose}>
                    <Modal.Header onClose={onClose}>
                        <Modal.Title>
                            <TranslationText tKey='sandhills.tradepubwebsite.mvc.sortby' />
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p id='description-label' className='hidden'>Sort results</p>
                        {props.SortOptions.map((sortItem) => <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); changeSort(sortItem.Key, sortItem.Value); } }} className={sortItem.Key == props.SelectedValue
                        ? 'sort-option selected-option'
                            : 'sort-option'} key={'mobile-' + sortItem.Key} onClick={() => { changeSort(sortItem.Key, sortItem.Value) }}>
                        {sortItem.Value}</a>)
                    }
                    </Modal.Body>
                </Modal>}
        </div>
    );
};

export default SortDropdown;